(function () {
  'use strict';
  var input = document.querySelector('[data-predictive-input]');
  var output = document.querySelector('[data-predictive-results]');
  if (!input || !output) return;
  var timer;
  var controller;
  function close() { output.hidden = true; output.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); }
  input.addEventListener('input', function () {
    window.clearTimeout(timer);
    var term = input.value.trim();
    if (term.length < 2) { close(); return; }
    timer = window.setTimeout(function () {
      if (controller) controller.abort();
      controller = new AbortController();
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root + 'search/suggest?q=' + encodeURIComponent(term) + '&section_id=predictive-search&resources[type]=product,collection,page,article&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller.signal }).then(function (response) {
        if (!response.ok) throw new Error('Predictive search failed');
        return response.text();
      }).then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var section = parsed.querySelector('#shopify-section-predictive-search');
        if (!section) { close(); return; }
        output.innerHTML = section.innerHTML;
        output.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }).catch(function (error) { if (error.name !== 'AbortError') close(); });
    }, 250);
  });
  document.addEventListener('click', function (event) { if (!output.contains(event.target) && event.target !== input) close(); });
  input.addEventListener('keydown', function (event) { if (event.key === 'Escape') close(); });
})();
